<template>
  <v-form ref="form" >
    
    <BaseUtil
      ref="util"
      :pageLoading="pageLoading"
    />

    <v-row>
      <v-col cols="12">
        <v-autocomplete
          v-model="entry.itemId"
          v-bind="getObject('itemId')"
          label="Item"
          :items="extraData.accountContext.availableItemsForStock"
          item-value="id"
          item-text="name"
          @input="selectItem"
          :hint="consumedItemAdditionalInfo(entry.item)"
          persistent-hint
          autocomplete="off"
          :disabled="readOnly"
        >
          <template v-slot:item="data">
            <v-list-item-content>
              <v-list-item-title>{{data.item.name}}</v-list-item-title>
              <v-list-item-subtitle>{{consumedItemAdditionalInfo(data.item)}}</v-list-item-subtitle>
            </v-list-item-content>
          </template>
        </v-autocomplete>
      </v-col>

      <v-col cols="12">
        <v-autocomplete
          :disabled="!entry.itemId || readOnly"
          v-model="entry.packagingId"
          v-bind="getObject('packagingId')"
          label="Embalagem"
          :items="packagingList"
          item-value="id"
          item-text="name"
          @input="selectPackaging"
          :loading="packagingListLoading"
          autocomplete="off"
        >
        </v-autocomplete>
      </v-col>

      <v-col cols="12" sm="6">
        <MaskedTextField
          v-if="renderComponent"
          :inputData.sync="packagingQuantity"
          mask-type="currency_10d"
          label="Quantidade de Embalagens"
          :disabled="!entry.packagingId || readOnly"
          @update:inputData="changePackagingQuantity"
          autocomplete="off"
          :suffix="entry.packaging ? entry.packaging.text : ''"
          :key="packagingQuantityKey + 'packagingQuantity'"
        />
        <!--   -->
      </v-col>


      <v-col cols="12" sm="6">
        <MaskedTextField
          v-if="renderComponent"
          v-bind="getObject('quantity')"
          :inputData.sync="entry.quantity"
          mask-type="currency_10d"
          label="Quantidade Unitária"
          :suffix="entry.item ? entry.item.unit.name : ''"
          :disabled="!entry.packagingId || readOnly"
          autocomplete="off"
          :hint="quantityHint"
          persistent-hint
          @update:inputData="changeQuantity"
          :key="quantityKey + 'quantity'"
        />
      </v-col>

    </v-row>
  </v-form>
</template>

<script>

import MaskedTextField from "@shared_components/masked_text_field.vue"
import gql from 'graphql-tag'
import BaseUtil from "@shared_components/base_util.vue";

export default {
  data() {
    return {
      entryAttributes: {},
      packagingListLoading: false,
      packagingList: [],
      stockListLoading: false,
      stockList: [],
      renderComponent: true,
      availableQuantity: 0,
      packagingQuantity: 0,
      packagingQuantityKey: 0,
      quantityKey: 0,
      pageLoading: false,
    };
  },
  props: {
    entry: Object,
    extraData: Object,
    isEdit: { // utilizado para definir se o form é de edição
      type: Boolean,
      default: false
    },
    originalEntry: Object,
    stockTransfer: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    MaskedTextField: MaskedTextField,
    BaseUtil: BaseUtil,
  },
  created() {
    this.entryAttributes = this.setupEntryAttributes(this.entry);
    // console.log("consumed item", this.entry.item)

    if (this.entry.item && (this.isEdit || this.readOnly)) {
      let itemFromList = this.extraData.accountContext.availableItemsForStock.find(obj => obj.id == this.entry.itemId)
      if (!itemFromList) {
        this.extraData.accountContext.availableItemsForStock.unshift(this.entry.item)
      }
      this.selectItem(false);
      this.changeQuantity();
    }
  },
  mounted() {
  },
  computed: {
    quantityHint: function() {
      return this.entry.item ? "Quantidade disponível: " + this.numberToDecimal(this.availableQuantity) + " " + this.entry.item.unit.name : null
    }
  },
  watch: {
  },
  methods: {
    consumedItemAdditionalInfo: function(item) {
      let info = ""
      if (item) {
        info = 'Unidade de Consumo: ' + item.unit.name + (item.brand ? ', Marca: ' + item.brand.name : '') + (item.typeText ? ', Tipo: ' + item.typeText : '')
      }
      return info;
    },
    getObject: function(element, component) {
      return this.entryAttributes[element];
    },
    isFormValid: function() {
      if (this.$refs.form.validate()) {
        return true;
      } else {
        setTimeout(function(){
          document.querySelector(".v-messages.error--text:first-of-type").scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 500);
      }
      return false;
    },
    resetFormInputs: function() {
      this.$refs.form.resetValidation();
    },
    selectItem: function(clearPackagingAndStock=false) {
      // console.log("entry.item", this.entry.item);
      if (this.entry.itemId) {
        this.entry.item = this.extraData.accountContext.availableItemsForStock.find(obj => obj.id == this.entry.itemId);
        // this.clearFields();
        if (clearPackagingAndStock) {
          this.entry.packagingId = null;
          this.entry.packaging = null;
        }
        this.packagingListLoading = true;
        this.$apollo
          .query({
            query: AVAILABLE_PACKAGING_FOR_ITEM_QUERY,
            fetchPolicy: "no-cache",
            variables: {
              itemId: this.entry.itemId,
              stockId: this.stockTransfer.sourceStockId
            }
          })
          .then(response => {
            // console.log("response dos packaging", response);
            this.packagingList = response.data.accountContext.availableItemPackagingsForStock;
            let clearStock = false;

            if (this.entry.item && this.isEdit) {
              let packagingFromList = this.packagingList.find(obj => obj.id == this.entry.packagingId)
              if (!packagingFromList) {
                this.packagingList.unshift(this.entry.packaging)
              }
            }

            if (this.packagingList.length == 1 && !this.entry.packagingId) {
              this.entry.packagingId = this.packagingList[0].id;
              clearStock = clearPackagingAndStock;
            }
            this.selectPackaging();
          })
          .catch(response => console.log(response))
          .finally(() => (this.packagingListLoading = false));
      }
    },
    selectPackaging: function() {
      if (this.entry.packagingId) {
        this.entry.packaging = this.packagingList.find(obj => obj.id == this.entry.packagingId);
        this.stockListLoading = true;
        this.$apollo
          .query({
            query: AVAILABLE_QUANTITY_FOR_ITEM_QUERY,
            fetchPolicy: "no-cache",
            variables: {
              itemId: this.entry.itemId,
              packagingId: this.entry.packagingId,
              stockId: this.stockTransfer.sourceStockId
            }
          })
          .then(response => {
            // console.log("response dos stocks", response)
            this.availableQuantity = response.data.accountContext.availableQuantityForItem;

            this.entryAttributes.quantity.rules = [];
            this.entryAttributes.quantity.rules.push(this.requiredRule);
            this.entryAttributes.quantity.rules.push(this.minRequiredRule);
            let availableQuantity = _.round(this.availableQuantity, 10);
            // usado para contabilizar a quantidade já salva no edit
            if (this.isEdit) {
              availableQuantity = _.round(availableQuantity + this.originalEntry.quantity, 10);
            }
            this.entryAttributes.quantity.rules.push(this.maxValueRule(availableQuantity));
          })
          .catch(response => console.log(response))
          .finally(() => (this.stockListLoading = false));
      }
    },
    clearFields: function() {
      this.forceRerender(this);
    },
    changeQuantity: function() {
      this.packagingQuantity = _.round(this.entry.quantity / this.entry.packaging.size, 10);
      this.packagingQuantityKey++;
    },
    changePackagingQuantity: function() {
      this.entry.quantity = _.round(this.packagingQuantity * this.entry.packaging.size, 10);
      this.quantityKey++;
    },
  }
};

const AVAILABLE_PACKAGING_FOR_ITEM_QUERY = gql `
  query ($itemId: ID!, $stockId: ID!) {
    accountContext {
      availableItemPackagingsForStock(itemId: $itemId, stockId: $stockId){
        id
        name
        text
        size
      }
    }
  }
`;

const AVAILABLE_QUANTITY_FOR_ITEM_QUERY = gql `
  query ($itemId: ID!, $packagingId: ID!, $stockId: ID!) {
    accountContext {
      availableQuantityForItem(itemId: $itemId, packagingId: $packagingId, stockId: $stockId)
    }
  }
`;

</script>

<style scoped></style>
